<template>
  <base-button
    v-if="product?.sizeChart"
    id="pdp-size-chart"
    :class="brandClasses.sizeAndFitButton"
    @click="openSizeGuide({ showFitRating: true })"
  >
    <vf-icon name="size" :size="sizeAndFit.iconSize" />
    {{ $t.findYourSize }}
  </base-button>
</template>

<script lang="ts" setup>
const { openSizeGuide, product } = usePdp()
const { brandClasses, sizeAndFit } = useAppConfig().pages.pdp
</script>
